import { render, staticRenderFns } from "./SendNotification.vue?vue&type=template&id=1b925ec6&scoped=true&"
import script from "./SendNotification.vue?vue&type=script&lang=ts&"
export * from "./SendNotification.vue?vue&type=script&lang=ts&"
import style0 from "./SendNotification.vue?vue&type=style&index=0&id=1b925ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b925ec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b925ec6')) {
      api.createRecord('1b925ec6', component.options)
    } else {
      api.reload('1b925ec6', component.options)
    }
    module.hot.accept("./SendNotification.vue?vue&type=template&id=1b925ec6&scoped=true&", function () {
      api.rerender('1b925ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/SendNotification.vue"
export default component.exports